import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-notification/es/index.js
// module id = 309
// module chunks = 0